<section class="concept-form">
  @if ((concept.processStates && taskEdit.task.taskTypeId === 7) || !(taskEdit.task.taskTypeId === 4 || taskEdit.task.taskTypeId === 5 || !taskEdit.task.taskId)) {
    <states-process
      [type]="taskEdit.typeStatesProcess"
      [typeView]="'normal'"
      [concept]="taskEdit.concept"
      [item]="taskEdit.task"
      (changeState)="changeState($event)"
      (changeResponsible)="changeResponsible($event)">
    </states-process>
  }
  <div class="landing-page__form-container">
    <aside class="concept-form__side-panels-landing">
      <attachments-template [typeFrom]="'task'"
        [itemSelected]="taskEdit.task"
        [concept]="taskEdit.concept"
        [attachmentList]="taskEdit.attachmentListDocument"
        (launchAction)="launchAction($event)">
      </attachments-template>
      <box-comments [taskId]="taskEdit.task.taskId"
        [taskState]="taskEdit.task.taskStateId"
        (launchAction)="launchAction($event)">
      </box-comments>
      <task-historic [historicList]="taskEdit.historicList"
        [task]="taskEdit.task">
      </task-historic>
    </aside>
    <task-form class="concept-form__form-landing-container"
      [concept]="taskEdit.concept"
      [task]="taskEdit.task"
      [shared]="taskEdit.shared"
      (cancelTask)="cancelCreateTask()"
      (createAlert)="createAlert($event.alert)"
      (launchAction)="launchAction($event.action)">
    </task-form>
  </div>
</section>
